import { createEntityAdapter } from '@reduxjs/toolkit';

const campaignsAdapter = createEntityAdapter();

export default campaignsAdapter;
